export default {
  brandList: (state) => {
    return state.brandList;
  },
  classList: (state) => {
    return state.classList;
  },
};
